/* src/app/settings/pages/user-roles/user-roles.component.scss */
/*# sourceMappingURL=user-roles.component.css.map */
